import React, { useEffect } from 'react';

type PulsingTextProps = {
    myKey?: string | number | bigint;
    children: React.ReactNode;
    fromColor?: string;
    toColor?: string;
    durationMs?: number;
    styles?: {
        alignContent?:
        | 'flex-start'
        | 'flex-end'
        | 'center'
        | 'stretch'
        | 'space-between'
        | 'space-around'
        | undefined;
        fontSize?: number;
        fontWeight?:
        | 'normal'
        | 'bold'
        | '100'
        | '200'
        | '300'
        | '400'
        | '500'
        | '600'
        | '700'
        | '800'
        | '900'
        | undefined;
    };
};

const STYLE_ID = 'pulsing-text-style';


export default function PulsingText({
    children,
    styles,
    fromColor = '#9ca3af',
    toColor = '#ef4444',
    durationMs = 1500,
    myKey,
}: PulsingTextProps) {

    useEffect(() => {
        let style = document.getElementById(`${STYLE_ID}${myKey ? '-' + myKey : ''}`) as HTMLStyleElement | null;

        if (!style) {
            style = document.createElement('style');
            style.id = `${STYLE_ID}${myKey ? '-' + myKey : ''}`;
            document.head.appendChild(style);
        }

        style.innerHTML = `
            @keyframes pulsingText${myKey ? '-' + myKey : ''} {
                0%   { color: ${fromColor}; }
                50%  { color: ${toColor}; }
                100% { color: ${fromColor}; }
            }
        `;
    }, [fromColor, toColor, myKey]);

    return (
        <span
            style={{
                animation: `pulsingText${myKey ? '-' + myKey : ''} ${durationMs}ms ease-in-out infinite`,
                fontFamily: 'Open Sans',
                ...(styles ? styles : {})
            }}
        >
            {children}
        </span>
    );
}
